"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._SelfServiceFittecWrappedReferences = void 0;
exports._SelfServiceFittecWrappedReferences = {
    fittecWrappedContainer: {
        required: false,
        uid: 'fittec-wrapped',
        description: 'Container for the wrapped',
    },
};
